// import React from 'react';
// import { Container, Typography, Box } from '@mui/material';

// const TermsAndConditions = () => {
//   return (
//    <div  style={{padding: '60px 0' }}>
//      <Container maxWidth="lg">
//       <Box mt={0} p={4} bgcolor="#f9f9f9" borderRadius={2}>
//         <Typography variant="h2" gutterBottom align="center"  sx={{
//             fontFamily: '"Poppins", "Arial", sans-serif',
//             fontWeight: 'bold',
//             letterSpacing: 0.3,
//             textTransform: 'uppercase',
//             position: 'relative',
//             fontSize: '24px',
//             marginBottom: '20px',
//             textShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
//           }}>
//           Terms and Conditions
//         </Typography>
//         <Typography variant="h6" gutterBottom>
//         <strong>Privacy Policy</strong>
//         </Typography>
//         <Typography variant="body1" paragraph>
//           At YND Auto Parts, we prioritize the privacy and security of our customers. This Privacy Policy outlines how we collect, use, and protect your personal information when you visit our website, purchase products, or interact with our services.
//         </Typography>
        
//         <Typography variant="body1" paragraph>
//           <strong>1. Information We Collect</strong>
//           <br />
//           We may collect personal information such as your name, email address, shipping address, and payment details during checkout. Additionally, we gather non-personal data like browser type, IP address, and pages visited.
//         </Typography>
        
//         <Typography variant="body1" paragraph>
//           <strong>2. How We Use Your Information</strong>
//           <br />
//           Your information is used to:
//           <ul>
//             <li>Process orders and deliver products.</li>
//             <li>Communicate with you about your orders and our services.</li>
//             <li>Improve our website, products, and services.</li>
//           </ul>
//           We do not sell or share your personal information with third parties, except for trusted partners necessary for payment processing and shipping.
//         </Typography>
        
//         <Typography variant="body1" paragraph>
//           <strong>3. Cookies</strong>
//           <br />
//           Our website may use cookies to enhance your browsing experience. You may disable cookies in your browser settings, though it may impact some features on the site.
//         </Typography>
        
//         <Typography variant="body1" paragraph>
//           <strong>4. Data Security</strong>
//           <br />
//           We implement various security measures to safeguard your data, including encryption technologies for transactions and secure data storage. However, no online transaction is 100% secure, so please take care when sharing sensitive information.
//         </Typography>
        
//         <Typography variant="body1" paragraph>
//           <strong>5. Third-Party Links</strong>
//           <br />
//           Our website may contain links to third-party sites. We are not responsible for the privacy practices or content of these websites.
//         </Typography>
        
//         <Typography variant="body1" paragraph>
//           <strong>6. Your Rights</strong>
//           <br />
//           You can request to review, update, or delete your personal data by contacting us at <a href="mailto:contact@yndautoparts.com" style={{
//                         color: '#d32f2fb3',
//                         textDecoration: 'none',
//                         fontSize: '16px',
//                         transition: 'color 0.3s ease' 
//                       }}
//                       onMouseEnter={(e) => e.currentTarget.style.color = '#d32f2f'} 
//                       onMouseLeave={(e) => e.currentTarget.style.color = '#d32f2fb3'} 
//                     >mailto:contact@yndautoparts.com</a>. We respect your rights to data protection under applicable privacy laws.
//         </Typography>
        
//         <Typography variant="body1" paragraph>
//           <strong>7. Changes to This Policy</strong>
//           <br />
//           We may update this Privacy Policy periodically. Any changes will be posted on this page with an updated revision date.
//         </Typography>
        
//         <Typography variant="body1" paragraph>
//           For any concerns regarding our Privacy Policy, please reach out to us at <a href="mailto:contact@yndautoparts.com" style={{
//                         color: '#d32f2fb3',
//                         textDecoration: 'none',
//                         fontSize: '16px',
//                         transition: 'color 0.3s ease' 
//                       }}
//                       onMouseEnter={(e) => e.currentTarget.style.color = '#d32f2f'} 
//                       onMouseLeave={(e) => e.currentTarget.style.color = '#d32f2fb3'} 
//                     >mailto:contact@yndautoparts.com</a>.
//         </Typography>
        
//         <Typography variant="body1" paragraph>
//           This privacy policy is customized to reflect your specific business operations. Let me know if you’d like any changes!
//         </Typography>
//       </Box>
//     </Container>
//    </div>
//   );
// };

// export default TermsAndConditions;


import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const TermsAndConditions = () => {
  return (
   <div style={{ padding: '60px 0' }}>
     <Container maxWidth="lg">
      <Box mt={0} p={4} bgcolor="#f9f9f9" borderRadius={2}>
        <Typography variant="h2" gutterBottom align="center" sx={{
            fontFamily: '"Poppins", "Arial", sans-serif',
            fontWeight: 'bold',
            letterSpacing: 0.3,
            textTransform: 'uppercase',
            position: 'relative',
            fontSize: '24px',
            marginBottom: '20px',
            textShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
          }}>
          Terms & Conditions – YND Autoparts
        </Typography>
        
        <Typography variant="body1" paragraph>
          <strong>1. Refund & Return Policy</strong>
          <br />
          At YND Autoparts, we strive to provide high-quality used and remanufactured auto parts. Our return and refund policies ensure a hassle-free experience for our customers.
          <ul>
            <li><strong>90-Day Replacement Guarantee:</strong> If the part you receive is faulty or defective, we will replace it free of charge. If a replacement is unavailable, we will issue a full refund.</li>
            <li><strong>Customer-Initiated Returns:</strong>
              <ul>
                <li>A 30% restocking fee will be charged.</li>
                <li>The customer bears the return shipping cost.</li>
                <li>Refunds are processed only after a thorough inspection of the returned product.</li>
                <li>If a part is damaged due to improper installation by the customer, the warranty is void, and no refund will be issued.</li>
              </ul>
            </li>
          </ul>
        </Typography>
        
        <Typography variant="body1" paragraph>
          <strong>2. Order Cancellation Policy</strong>
          <br />
          <ul>
            <li><strong>Before Shipment:</strong> Customers can cancel an order before it is shipped, but a 20% cancellation fee will be applied.</li>
            <li><strong>After Shipment:</strong>
              <ul>
                <li>The customer must pay return shipping costs.</li>
                <li>A 30% restocking fee will apply.</li>
              </ul>
            </li>
          </ul>
        </Typography>
        
        <Typography variant="body1" paragraph>
          <strong>3. Shipping Policy</strong>
          <br />
          <ul>
            <li><strong>Estimated Delivery Time:</strong>
              <ul>
                <li>Canada & USA: 7-10 working days.</li>
              </ul>
            </li>
            <li><strong>Shipping Carriers:</strong> We use UPS, FedEx, Day & Ross, R&L, and other shipping providers based on the requirement.</li>
            <li><strong>Tracking:</strong> Once the package is picked up, a tracking number will be provided.</li>
            <li><strong>Refused Shipments:</strong> If a customer refuses delivery, they must bear the return shipping costs.</li>
          </ul>
        </Typography>
        
        <Typography variant="body1" paragraph>
          <strong>4. Warranty Policy</strong>
          <br />
          <ul>
            <li><strong>Standard Warranty:</strong> 90-day replacement warranty on all parts.</li>
            <li><strong>Extended Warranty:</strong> Some remanufactured parts come with a 1-year warranty (please confirm before purchase).</li>
            <li><strong>Warranty Void Conditions:</strong> If the part is damaged due to improper installation by the customer, the warranty is void, and no refund/replacement will be issued.</li>
          </ul>
        </Typography>
        
        <Typography variant="body1" paragraph>
          <strong>5. Liability Disclaimer</strong>
          <br />
          YND Autoparts is not responsible for any damage caused due to improper installation or misuse of the product. We highly recommend professional installation for all auto parts.
        </Typography>
        
        <Typography variant="body1" paragraph>
          <strong>6. Contact Information</strong>
          <br />
          For any questions or concerns, feel free to contact us:
          <br />
          📍 Head Office: 8316 Tenth Line N, Norval, ON
          <br />
          📧 Email: <a href="mailto:contact@yndautoparts.com" style={{ color: '#d32f2fb3', textDecoration: 'none', fontSize: '16px', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.currentTarget.style.color = '#d32f2f'} onMouseLeave={(e) => e.currentTarget.style.color = '#mailto:d32f2fb3'}>contact@yndautoparts.com</a>
          <br />
          📞 Phone: 888-927-5557
        </Typography>
      </Box>
    </Container>
   </div>
  );
};

export default TermsAndConditions;
